import { render, staticRenderFns } from "./provideRecords.vue?vue&type=template&id=2908d24b&scoped=true&"
import script from "./provideRecords.vue?vue&type=script&lang=js&"
export * from "./provideRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908d24b",
  null
  
)

export default component.exports